import { useEffect, useMemo, useState } from 'react';
import { Link } from "react-router";
import { AppBar, Autocomplete, Avatar, Box, Container, debounce, IconButton, Menu, MenuItem, Modal, TextField, Toolbar, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../../images/terrapixel.png';

import { useUser } from '../../store/User';
import Profile from '../Profile';
import { Login } from '../Profile/login';
import { apiUrl } from '../../api';
import users from '../../data/users.json';
import './index.css';

const pages = ['map', 'documents'];

const Header = () => {
  const { login, mapConfig, mapContext, user, setAOI, setAOIs, setMapConfig, setLocation, setShowLogin, setTacticalTerraBase, setTerraBase, setWorldTerraBase, setUser } = useUser();
  
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [showProfile, setShowProfile] = useState(false);

  useEffect(() => {
      checkCreds();
  }, [user?.id]);

  const checkCreds = async() => {
    try {
      let userCreds = null;
      if (user?.id) {
        userCreds = users.users.find(u => u.id === user.id);
      } else {
        userCreds =  users.users.find(u => u.email === localStorage.getItem('terra-email') && u.password === localStorage.getItem('terra-password'));
      }
      
      if (userCreds) {
        setUser(userCreds);
      } else {
        setShowLogin(true);
      }
    } catch (error) {
        console.error("Error fetching User:", error);
    }
  }

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogin = () => {
    setShowLogin(true);
    setAnchorElUser(null);
  }

  const handleProfile = () => {
    setShowProfile(true);
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    logout();
    localStorage.removeItem('terra-token');
    localStorage.removeItem('terra-email');
    localStorage.removeItem('terra-password');
    setAnchorElUser(null);

  };

  const logout = () => {
    setAOI(null);
    setUser(null);
    setAOIs([]);
    setTerraBase(null);
    setTacticalTerraBase(null);
    setWorldTerraBase(null);
    setShowLogin(true);
    setMapConfig({
      ...mapConfig,
      world: false,
      tactical: false,
      mgrs: false,
      drawPolygons: false
    });
  }

  // const fetchLocations = useMemo(
  //   () =>
  //     debounce(async (query) => {
  //       if (!query) return;
  //       setLoading(true);
  //       if (/\d/.test(query) && query.length >= 2) {
  //         try {
  //           const response = await fetch(`${apiUrl}/mgrs/${query}`, {
  //             headers: {
  //               'Authorization': `Bearer ${localStorage.getItem('terra-token')}`
  //             },
  //           });
  //           if (response.ok) {
  //             const data = await response.json();
  //             setOptions(data);
  //           } else if(response.status === 401) {
  //             setUser(null);
  //             setShowLogin(true);
  //           }
  //         } catch (error) {
  //           console.error("Fetch error:", error);
  //         } finally {
  //           setLoading(false);
  //         }
  //       } else if (query.length >= 3) {
  //         try {
  //           const response = await fetch(`${apiUrl}/locations/${query}`, {
  //             headers: {
  //               'Authorization': `Bearer ${localStorage.getItem('terra-token')}`
  //             },
  //           });

  //           const data = await response.json();

  //           if (response.ok) {
  //             setOptions(data);
  //           } else if(response.status === 401) {
  //             setUser(null);
  //             setShowLogin(true);
  //           }
  //         } catch (error) {
  //           console.error("Fetch error:", error);
  //         } finally {
  //           setLoading(false);
  //         }
  //       }
  //     }, 500),
  //   []
  // );

  return (
    <AppBar className="header" position="static" sx={{ backgroundColor: "#000", borderBottom: '1px solid #4c4c4c' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
            <MenuIcon style={{ color: "#1aa34a" }}/>
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Link to={page === 'map' ? `/` : `/${page}`}>
                    {page}
                  </Link>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Link to="/"><img src={logo} alt="logo" style={{ width: 200, height: 'auto' }} /></Link>
          <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'center', alignItems: 'center'}}>
            <Autocomplete
              id="search-autocomplete"
              freeSolo
              options={options}
              renderInput={(params) => <TextField {...params} label="Search Location" />}
              getOptionKey={(option) => (typeof option === 'string' ? option : option.id)}
              getOptionLabel={(option) => 
                typeof option === 'string' 
                  ? option 
                  : (option.city ? `${option.city}, ${option.country}` : option.name) ?? ""
              }
              sx={{ width: 300 }}
              variant="outlined" 
              size="small"
              // onInputChange={(event, newInputValue) => {
              //   fetchLocations(newInputValue);
              // }}
              onChange={(event, value) => {
                if (value && typeof value !== 'string') {
                  if(value.latitude && value.longitude) {
                    const lat = parseFloat(value.latitude);
                    const lon = parseFloat(value.longitude);
                    setLocation([lon, lat]);

                    if(mapContext) {
                      mapContext.flyTo([lat, lon], 9, { 
                          padding: [100, 100], 
                          // maxZoom: 10,
                          duration: 2
                      });
                    }
                  }
                } else {
                  setLocation(null);
                }
              }}
              filterOptions={(x) => x}
              loading={loading}
            />
          </Box>
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            { pages.map((page) => (
              <div key={`nav-link-${page}`} className="nav-link">
                <Link to={page === 'map' ? `/` : `/${page}`}>{page}</Link>
              </div>
            ))}
          </Box>
          <Box sx={{ flexGrow: 0, ml: 4 }}>
            <Tooltip title="Open Settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar sx={{ width: 30, height: 30, fontSize: '1.5rem', bgcolor: user ? '#1aa34a' : '#4c4c4c' }} alt={user?.name} src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {user ? [
                <MenuItem key="profile" dense onClick={handleProfile}>
                  PROFILE
                </MenuItem>,
                <MenuItem key="logout" dense onClick={handleLogout}>
                  LOGOUT
                </MenuItem>
              ] : (
                <MenuItem dense onClick={handleLogin}>
                  LOGIN
                </MenuItem>
              )}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
      <Modal
        open={showProfile}
        onClose={() => setShowProfile(!showProfile)}
        className="terra-modal"
      >
        <Profile viewModal={setShowProfile} />
      </Modal>

      <Modal
        open={login}
        onClose={() => setShowLogin(!login)}
        className="terra-modal"
      >
        <Login viewModal={setShowLogin} />
      </Modal>
    </AppBar>
  );
}

export default Header;